import { UnroutedWorkflow } from '~/features/workflow-routing/types';
import { everest } from '~/services/serviceInstances';

import { ServerUnroutedWorkflow } from '../../types/routings/routes';

type ServerResponse = {
  data: ServerUnroutedWorkflow[];
};

export const getUnroutedWorkflows = async (): Promise<UnroutedWorkflow[]> => {
  const response: ServerResponse = await everest.get(
    '/routing/unrouted-workflows',
  );

  return response.data.map((workflow) => ({
    workflowId: workflow.workflowId,
    name: workflow.name,
    description: workflow.description,
  }));
};
